import * as Yup from 'yup';
import { nameRequired } from '.';

export const d7ProspectSearchSchema = Yup.object({
    niche: nameRequired,
    city: nameRequired,
    state: nameRequired,
    country: nameRequired
});

export const lsProspectSearchSchema = Yup.object({
    niche: nameRequired,
    location: nameRequired
});

export const manualProspectSchema = Yup.object({
    title: nameRequired,
    city: nameRequired,
    state: nameRequired,
    country: nameRequired
});
